import * as React from "react";
import useHistory from "./useHistory";
const withParams = (Component) => (props) => {
  const history = useHistory();
  return /* @__PURE__ */ React.createElement(Component, { ...props, history });
};
export default withParams;
